export default String.raw`
.lookbook {
    padding: 0 5% 32px 5%;

    &__container {
        grid-template-columns: 100%;
        row-gap: 24px;

        h2 {
            @include h4-headline;
        }
    }

    &__item {
        &-product {
            padding: 8px;
            width: 200px;
            &.middle {
                left: -92px !important;
                right: auto !important;
            }
        }
    }
}
`